/* Movatic WMS — Coletor | Tradução de motivos p/ linguagem de operador (ADR-0058 D3) | CesarFilho 932048016 */
// UM só sítio: mapeia o motivo TÉCNICO do backend (`detail`) para linguagem de chão de armazém.
// O operador nunca vê jargão de modelo de dados. Texto não mapeado passa como veio — nunca
// engolir o motivo. Usado pelo LoginScanGate (gate de scan) e pelo PresenceGate (falha cedo, F2).

const OPERATOR_MESSAGES: Record<string, string> = {
  'Device inexistente, inativo ou de outra empresa.':
    'Coletor não registado nesta empresa ou inativo.',
  'device_id ou device_code obrigatorio.':
    'Leitura inválida — pica outra etiqueta.',
  // ADR-0058 F2: literal de _require_operator (workforce_api/views.py) — utilizador sem Operator.
  'Nenhum Operator vinculado ao usuario autenticado.':
    'Esta conta não tem perfil de operador.',
}

export function operatorMessage(detail: string): string {
  return OPERATOR_MESSAGES[detail.trim()] ?? detail
}
